export const dataInfo = [
  {
    adress: "MAX WAY ALAYSKIY",
    street: "проспект Амира Темура, 25",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY BERUNIY",
    street: "улица Беруни, 47, Ташкент",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY AVIASOZLAR",
    street: "улица Авиасозлар, 23",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY RISOVIY ",
    street: "Узбекистан, Ташкент, Алтынкульская улица, 10",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY PARUS",
    street: "улица Катартал, 60/5",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY PARKENT",
    street: "улица Паркент, 30В, Ташкент",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY UNIVERSAM",
    street: "Узбекистан, Ташкент, проспект Амира Темура, 41/3",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY ROYSON",
    street: "Узбекистан, Ташкент, улица Заркайнар, 2",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY MUQUMIY",
    street: "улица Чиланзар, Ташкент",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY GRAND MIR",
    street: "Узбекистан, Ташкент, улица Шота Руставели, 9А",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY SAYRAM",
    street: "Узбекистан, Ташкент, улица Юнусота",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY MAKSIM GORKIY",
    street: "махалля Элобод",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY SERGELI",
    street: "Узбекистан, Ташкент, Сергелийский район, массив Сергели-VIIIА, 11",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY FONTAN",
    street: "проспект Амира Темура",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
  {
    adress: "MAX WAY MINOR",
    street: "улица Осиё, 84А, Юнусабадский район, Ташкент",
    open: "Closed until 10:00",
    time: "Schedule:",
    week: "Mon-Sun: 10:00-03:00",
    phone: "Phone:",
    number: "+998712005400",
  },
];
